import { isEmpty, sortBy } from 'lodash-es';
import { ViewStudy } from '../view/view-study';
import { Identifiable } from './identifiable';
import { SeriesElement } from './SeriesElement';
import { Study } from './Study';

export class Patient implements Identifiable {
    id: string;
    name: string;
    sex: string;
    birthDate: string;
    data: Map<string, Study>;

    constructor(seriesElement: SeriesElement) {
        this.id = seriesElement.getPatientId();
        this.name = seriesElement.getPatientName();
        this.sex = seriesElement.getPatientSex();
        this.birthDate = seriesElement.getPatientBirthDate();
        this.data = new Map();
    }

    getId(): string {
        return this.id;
    }

    addSeriesElement(e: SeriesElement) {
        let study: Study | undefined = this.data.get(e.getStudyId());
        if (!study) {
            study = new Study(e);
            this.data.set(e.getStudyId(), study);
        }
        study.addSeriesElement(e);
    }

    getName(): string {
        if (!isEmpty(this.name) && this.name.includes('^')) {
            this.name = this.name.replace(/\^/g, ' ');
        }
        return this.name;
    }

    getSex(): string {
        return this.sex;
    }

    getBirthDate(): string {
        return this.birthDate;
    }

    convertToViewStudy(): ViewStudy[] {
        const p = {
            id: this.id,
            name: this.getName(),
            sex: this.sex,
            birthDate: this.birthDate,
        };
        return sortBy(
            [...this.data.values()].map((e: Study) => e.convertToViewStudy(p)),
            (x) => x.data.id,
        );
    }
}
